
        import { isLoggedIn, login, getUser, authHeaders } from '/src/auth.ts';

        const authGate = document.getElementById('ordersAuthGate');
        const ordersContent = document.getElementById('ordersContent');
        const ticketChatView = document.getElementById('ticketChatView');
        const ticketsList = document.getElementById('ticketsList');
        const noTicketsMsg = document.getElementById('noTicketsMsg');
        const ticketForm = document.getElementById('ticketForm');
        const chatForm = document.getElementById('chatForm');
        const chatMessages = document.getElementById('chatMessages');
        const backToTickets = document.getElementById('backToTickets');

        let currentTicketId = null;
        let pollInterval = null;

        const ordersList = document.getElementById('ordersList');
        const noOrdersMsg = document.getElementById('noOrdersMsg');

        // Auth check
        if (isLoggedIn()) {
            authGate.style.display = 'none';
            ordersContent.style.display = 'block';
            loadOrders();
            loadTickets();
        } else {
            document.getElementById('ordersLoginBtn').addEventListener('click', () => {
                localStorage.setItem('discord_redirect_back', window.location.href);
            });
        }

        // Load user's orders
        async function loadOrders() {
            const user = getUser();
            if (!user) return;

            try {
                const res = await fetch('/api/orders', { headers: authHeaders() });
                const data = await res.json();

                if (data.orders && data.orders.length > 0) {
                    noOrdersMsg.style.display = 'none';
                    ordersList.innerHTML = '';
                    data.orders.forEach(order => {
                        const el = document.createElement('div');
                        el.style.cssText = 'background: var(--bg-white); border: 1px solid var(--border-color); border-radius: 15px; padding: 1.25rem; display: flex; justify-content: space-between; align-items: center; cursor: pointer; transition: all 0.2s ease;';
                        el.onmouseenter = () => { el.style.borderColor = '#C9A96E'; el.style.transform = 'translateY(-1px)'; };
                        el.onmouseleave = () => { el.style.borderColor = ''; el.style.transform = ''; };

                        const statusColors = {
                            'Processing': '#f39c12',
                            'Completed': '#2ecc71',
                            'Delivered': '#3498db',
                            'Cancelled': '#dc3545',
                            'Pending Payment': '#f39c12',
                            'Paid — Awaiting Processing': '#3498db',
                            'Tracking': '#2ecc71',
                            'Refunded': '#dc3545',
                        };
                        const sColor = statusColors[order.status] || '#A89B8C';

                        const typeIcons = {
                            'Gift Card': '🎁',
                            'Mealkit': '🍽️',
                            'Food Delivery': '🚗',
                        };
                        const icon = typeIcons[order.type] || '📦';

                        el.innerHTML = `
                            <div style="flex: 1; min-width: 0;">
                                <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.35rem;">
                                    <span style="font-size: 1.1rem;">${icon}</span>
                                    <span style="font-family: 'Inter', sans-serif; font-weight: 600; color: var(--text-dark); font-size: 0.95rem;">${order.type}</span>
                                    <span style="display: inline-flex; align-items: center; gap: 0.35rem; font-size: 0.75rem; font-weight: 600; color: ${sColor}; background: ${sColor}15; padding: 0.15rem 0.5rem; border-radius: 20px;">
                                        <span style="width: 6px; height: 6px; border-radius: 50%; background: ${sColor};"></span>
                                        ${order.status}
                                    </span>
                                </div>
                                <p style="color: var(--text-medium); font-size: 0.85rem; margin: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${order.description}</p>
                                <div style="display: flex; align-items: center; gap: 1rem; margin-top: 0.35rem;">
                                    <span style="font-size: 0.8rem; color: var(--text-light);">${new Date(order.createdAt).toLocaleDateString()}</span>
                                    <span style="font-size: 0.85rem; font-weight: 600; color: #C9A96E;">${order.amount}</span>
                                </div>
                            </div>
                            <div style="display: flex; align-items: center; gap: 0.75rem; margin-left: 1rem;">
                                <button class="btn-secondary order-help-btn" data-order-id="${order.id}" data-order-type="${order.type}" data-order-desc="${order.description}" style="padding: 0.5rem 1rem; font-size: 0.85rem; white-space: nowrap;">Get Help</button>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--text-medium)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;">
                                    <polyline points="9 18 15 12 9 6"></polyline>
                                </svg>
                            </div>
                        `;

                        // Click row to open dashboard
                        el.addEventListener('click', (e) => {
                            if (e.target.closest('.order-help-btn')) return; // Don't navigate if clicking Get Help
                            if (order.type === 'Food Delivery') {
                                // Link to tracking page if order is placed, otherwise food delivery page
                                if (order.status === 'Placed' && order.trackingUrl) {
                                    window.location.href = `/food-delivery-success?orderId=${order.id}`;
                                } else {
                                    window.location.href = `/food-delivery?view=${order.id}`;
                                }
                            } else if (order.type === 'Gift Card') {
                                window.location.href = `/giftcard-order?id=${order.id}`;
                            }
                        });

                        ordersList.appendChild(el);
                    });

                    // Wire up Get Help buttons
                    ordersList.querySelectorAll('.order-help-btn').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const orderType = btn.dataset.orderType;
                            const orderDesc = btn.dataset.orderDesc;
                            const orderId = btn.dataset.orderId;

                            // Map order type to ticket subject value
                            const subjectMap = {
                                'Gift Card': 'giftcard',
                                'Mealkit': 'mealkit',
                                'Food Delivery': 'food-delivery',
                            };
                            const subjectVal = subjectMap[orderType] || 'other';

                            // Pre-fill the ticket form
                            const subjectSelect = document.getElementById('ticketSubject');
                            subjectSelect.value = subjectVal;
                            subjectSelect.style.color = '#F0E6D6';
                            document.getElementById('ticketMessage').value = `I need help with my order #${orderId} — ${orderDesc}`;

                            // Scroll to the ticket form
                            document.querySelector('.order-form-container').scrollIntoView({ behavior: 'smooth' });
                        });
                    });
                } else {
                    noOrdersMsg.style.display = 'block';
                    ordersList.querySelectorAll('div').forEach(el => el.remove());
                }
            } catch (err) {
                console.error('Failed to load orders:', err);
            }
        }


        // Load user's tickets
        async function loadTickets() {
            const user = getUser();
            if (!user) return;

            try {
                const res = await fetch('/api/tickets', { headers: authHeaders() });
                const data = await res.json();

                if (data.tickets && data.tickets.length > 0) {
                    noTicketsMsg.style.display = 'none';
                    ticketsList.innerHTML = '';
                    data.tickets.forEach(ticket => {
                        const el = document.createElement('div');
                        el.style.cssText = 'background: var(--bg-white); border: 1px solid var(--border-color); border-radius: 15px; padding: 1.25rem; cursor: pointer; transition: all 0.2s ease;';
                        el.onmouseenter = () => el.style.borderColor = '#C9A96E';
                        el.onmouseleave = () => el.style.borderColor = '';
                        
                        const statusColor = ticket.status === 'open' ? '#2ecc71' : '#A89B8C';
                        const statusText = ticket.status === 'open' ? 'Open' : 'Closed';
                        
                        el.innerHTML = `
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <h3 style="font-family: 'Inter', sans-serif; font-size: 1rem; font-weight: 600; color: var(--text-dark); margin-bottom: 0.25rem;">${ticket.subject}</h3>
                                    <p style="color: var(--text-medium); font-size: 0.85rem;">Opened ${new Date(ticket.createdAt).toLocaleDateString()}</p>
                                </div>
                                <div style="display: flex; align-items: center; gap: 0.5rem;">
                                    <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: ${statusColor};"></span>
                                    <span style="font-size: 0.85rem; color: ${statusColor}; font-weight: 600;">${statusText}</span>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--text-medium)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-left: 0.5rem;">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </div>
                            </div>
                        `;
                        el.addEventListener('click', () => openTicketChat(ticket));
                        ticketsList.appendChild(el);
                    });
                } else {
                    noTicketsMsg.style.display = 'block';
                }
            } catch (err) {
                console.error('Failed to load tickets:', err);
            }
        }

        // Open ticket form
        ticketForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            const user = getUser();
            if (!user) return;

            const subject = document.getElementById('ticketSubject').value;
            const message = document.getElementById('ticketMessage').value;
            const submitBtn = document.getElementById('submitTicketBtn');

            submitBtn.disabled = true;
            submitBtn.textContent = 'Opening ticket...';

            try {
                const res = await fetch('/api/tickets', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', ...authHeaders() },
                    body: JSON.stringify({
                        discordId: user.id,
                        username: user.global_name || user.username,
                        avatarUrl: user.avatar ? `https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png?size=128` : '',
                        subject: document.getElementById('ticketSubject').options[document.getElementById('ticketSubject').selectedIndex].text,
                        subjectValue: subject,
                        message,
                    }),
                });
                const data = await res.json();
                if (data.success) {
                    ticketForm.reset();
                    document.getElementById('ticketSubject').style.color = '#7A6F63';
                    await loadTickets();
                    // Open the newly created ticket
                    openTicketChat(data.ticket);
                } else {
                    alert(data.error || 'Failed to create ticket');
                }
            } catch (err) {
                console.error(err);
                alert('Failed to create ticket. Please try again.');
            } finally {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Open Ticket';
            }
        });

        // Open ticket chat
        function openTicketChat(ticket) {
            currentTicketId = ticket.id;
            ordersContent.style.display = 'none';
            ticketChatView.style.display = 'block';
            document.getElementById('chatTicketTitle').textContent = ticket.subject;
            document.getElementById('chatTicketStatus').textContent = `Ticket #${ticket.id.slice(-6).toUpperCase()} • ${ticket.status === 'open' ? 'Open' : 'Closed'}`;
            
            loadMessages();
            // Poll for new messages every 5 seconds
            if (pollInterval) clearInterval(pollInterval);
            pollInterval = setInterval(loadMessages, 5000);
        }

        // Close ticket from website — custom modal
        const confirmModal = document.getElementById('confirmModal');
        const confirmCloseBtn = document.getElementById('confirmClose');
        const confirmCancelBtn = document.getElementById('confirmCancel');

        document.getElementById('closeTicketBtn').addEventListener('click', () => {
            if (!currentTicketId) return;
            confirmModal.style.display = 'flex';
        });

        confirmCancelBtn.addEventListener('click', () => {
            confirmModal.style.display = 'none';
        });

        confirmModal.addEventListener('click', (e) => {
            if (e.target === confirmModal) confirmModal.style.display = 'none';
        });

        confirmCloseBtn.addEventListener('click', async () => {
            confirmModal.style.display = 'none';
            if (!currentTicketId) return;

            try {
                const res = await fetch(`/api/tickets/${currentTicketId}/close`, { method: 'POST', headers: authHeaders() });
                const data = await res.json();
                if (data.success) {
                    ticketChatView.style.display = 'none';
                    ordersContent.style.display = 'block';
                    currentTicketId = null;
                    if (pollInterval) clearInterval(pollInterval);
                    loadTickets();
                }
            } catch (err) {
                console.error(err);
            }
        });

        // Back to tickets list
        backToTickets.addEventListener('click', () => {
            ticketChatView.style.display = 'none';
            ordersContent.style.display = 'block';
            currentTicketId = null;
            if (pollInterval) clearInterval(pollInterval);
            loadTickets();
        });

        // Load messages for current ticket
        async function loadMessages() {
            if (!currentTicketId) return;

            try {
                const res = await fetch(`/api/tickets/${currentTicketId}/messages`, { headers: authHeaders() });
                const data = await res.json();

                if (data.messages) {
                    const user = getUser();
                    const wasScrolledToBottom = chatMessages.scrollHeight - chatMessages.clientHeight <= chatMessages.scrollTop + 50;
                    
                    chatMessages.innerHTML = '';
                    data.messages.forEach(msg => {
                        const isUser = msg.authorId === user.id;
                        const isBot = msg.isBot;
                        const div = document.createElement('div');
                        div.style.cssText = `
                            max-width: 80%;
                            padding: 0.75rem 1rem;
                            border-radius: 12px;
                            font-size: 0.95rem;
                            line-height: 1.5;
                            ${isUser 
                                ? 'align-self: flex-end; background: linear-gradient(135deg, #C9A96E, #D4B97A); color: #1A1714;' 
                                : isBot
                                    ? 'align-self: flex-start; background: rgba(201, 169, 110, 0.1); border: 1px solid rgba(201, 169, 110, 0.2); color: var(--text-dark);'
                                    : 'align-self: flex-start; background: var(--bg-white); border: 1px solid var(--border-color); color: var(--text-dark);'
                            }
                        `;
                        
                        const authorName = isUser ? 'You' : 'Support';
                        const time = new Date(msg.timestamp).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
                        
                        let attachmentHtml = '';
                        if (msg.attachment) {
                            if (msg.attachment.isImage) {
                                attachmentHtml = `<img src="${msg.attachment.url}" alt="${msg.attachment.name}" style="max-width: 100%; border-radius: 8px; margin-top: 0.5rem; cursor: pointer;" onclick="window.open('${msg.attachment.url}', '_blank')">`;
                            } else if (msg.attachment.isPdf) {
                                attachmentHtml = `
                                    <a href="${msg.attachment.url}" target="_blank" style="display: inline-flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem; padding: 0.5rem 0.75rem; background: rgba(201, 169, 110, 0.1); border: 1px solid rgba(201, 169, 110, 0.2); border-radius: 8px; text-decoration: none; color: #C9A96E; font-size: 0.85rem;">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                            <polyline points="14 2 14 8 20 8"></polyline>
                                        </svg>
                                        ${msg.attachment.name}
                                    </a>`;
                            } else {
                                attachmentHtml = `
                                    <a href="${msg.attachment.url}" target="_blank" style="display: inline-flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem; padding: 0.5rem 0.75rem; background: rgba(201, 169, 110, 0.1); border: 1px solid rgba(201, 169, 110, 0.2); border-radius: 8px; text-decoration: none; color: #C9A96E; font-size: 0.85rem;">
                                        ${msg.attachment.name}
                                    </a>`;
                            }
                        }

                        div.innerHTML = `
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.25rem;">
                                <span style="font-weight: 600; font-size: 0.8rem; ${isUser ? 'color: #1A1714;' : 'color: #C9A96E;'}">${authorName}</span>
                                <span style="font-size: 0.75rem; opacity: 0.7; margin-left: 1rem;">${time}</span>
                            </div>
                            ${msg.content ? `<div>${msg.content}</div>` : ''}
                            ${attachmentHtml}
                        `;
                        chatMessages.appendChild(div);
                    });

                    if (wasScrolledToBottom || chatMessages.children.length <= data.messages.length) {
                        chatMessages.scrollTop = chatMessages.scrollHeight;
                    }
                }
            } catch (err) {
                console.error('Failed to load messages:', err);
            }
        }

        // File attach button
        const fileInput = document.getElementById('fileInput');
        const attachBtn = document.getElementById('attachBtn');
        const filePreview = document.getElementById('filePreview');
        const fileNameSpan = document.getElementById('fileName');
        const removeFileBtn = document.getElementById('removeFile');

        attachBtn.addEventListener('click', () => fileInput.click());

        fileInput.addEventListener('change', () => {
            if (fileInput.files.length > 0) {
                fileNameSpan.textContent = fileInput.files[0].name;
                filePreview.style.display = 'flex';
            }
        });

        removeFileBtn.addEventListener('click', () => {
            fileInput.value = '';
            filePreview.style.display = 'none';
        });

        // Send message (with optional file)
        chatForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            const input = document.getElementById('chatInput');
            const message = input.value.trim();
            const file = fileInput.files[0];
            if (!message && !file) return;
            if (!currentTicketId) return;

            const user = getUser();
            const sendBtn = document.getElementById('sendMsgBtn');
            sendBtn.disabled = true;

            try {
                const formData = new FormData();
                formData.append('discordId', user.id);
                formData.append('username', user.global_name || user.username);
                if (message) formData.append('content', message);
                if (file) formData.append('file', file);

                const res = await fetch(`/api/tickets/${currentTicketId}/messages`, {
                    method: 'POST',
                    headers: authHeaders(),
                    body: formData,
                });
                const data = await res.json();
                if (data.success) {
                    input.value = '';
                    fileInput.value = '';
                    filePreview.style.display = 'none';
                    await loadMessages();
                }
            } catch (err) {
                console.error(err);
            } finally {
                sendBtn.disabled = false;
            }
        });
    